import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 5h-7l-4 14l-3 -6h-2","key":"svg-0"}],["path",{"d":"M14 13l6 6","key":"svg-1"}],["path",{"d":"M14 19l6 -6","key":"svg-2"}]]

/**
 * IconMath
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbWF0aCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTkgNWgtN2wtNCAxNGwtMyAtNmgtMiIgLz4KICA8cGF0aCBkPSJNMTQgMTNsNiA2IiAvPgogIDxwYXRoIGQ9Ik0xNCAxOWw2IC02IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/math
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMath = createReactComponent('outline', 'math', 'Math', __iconNode);

export default IconMath;